import { formatPhone } from "../../../utils/Formatters";

export const SMS_FOOTER = "\nReply STOP to unsubscribe.";
export const SMS_PROPERTY_SEPARATOR_LENGTH = 1;
export const SMS_SEGMENT_LIMIT = 160;
export function getAvailableMessageLength(propertyName) {
  const overhead = (propertyName?.length ?? 0) + SMS_PROPERTY_SEPARATOR_LENGTH + SMS_FOOTER.length;
  return Math.max(SMS_SEGMENT_LIMIT - overhead, 0);
}

/** Parses ResidentKey for API (CreateMessageRequest.ExcludedResidentKeys expects int). */
export function parseResidentKeyToInt(value) {
  if (value == null || value === "" || value === "—") return null;
  const s = String(value).trim();
  const n = parseInt(s, 10);
  if (!Number.isFinite(n)) return null;
  return n;
}

/**
 * Resident rows not selected in the table → keys to exclude on the server.
 */
export function buildExcludedResidentKeys(recipientRows, selectedRecipientKeys) {
  const selectedSet = new Set(selectedRecipientKeys);
  const excluded = new Set();
  for (const row of recipientRows) {
    if (!selectedSet.has(row.key)) {
      const n = parseResidentKeyToInt(row.residentContactKey);
      if (n !== null) excluded.add(n);
    }
  }
  return [...excluded];
}

export const RECIPIENT_EMPTY_VALUE = "—";

const cleanNamePart = (value) =>
  value == null || value === RECIPIENT_EMPTY_VALUE ? "" : String(value).trim();

export function sortRecipientsByLastName(rows) {
  return [...rows].sort((a, b) => {
    const lastA = cleanNamePart(a.lastName);
    const lastB = cleanNamePart(b.lastName);
    if (!lastA && lastB) return 1;
    if (lastA && !lastB) return -1;
    const lastCompare = lastA.localeCompare(lastB, undefined, { sensitivity: "base" });
    if (lastCompare !== 0) return lastCompare;

    const firstA = cleanNamePart(a.firstName);
    const firstB = cleanNamePart(b.firstName);
    if (!firstA && firstB) return 1;
    if (firstA && !firstB) return -1;
    return firstA.localeCompare(firstB, undefined, { sensitivity: "base" });
  });
}

export function normalizeRecipient(raw, index) {
  const id =
    raw.residentContactKey ??
    raw.ResidentContactKey ??
    raw.residentKey ??
    raw.ResidentKey ??
    raw.id ??
    raw.guid ??
    raw.userId ??
    `recipient-${index}`;
  const firstName = raw.firstName ?? raw.FirstName ?? "";
  const lastName = raw.lastName ?? raw.LastName ?? "";
  const phoneNumber = raw.phoneNumber ?? raw.PhoneNumber ?? "";
  const residentKey = raw.residentKey ?? raw.ResidentKey ?? "";
  const residentContactKey = raw.residentContactKey ?? raw.ResidentContactKey ?? "";
  const block = raw.block ?? raw.Block ?? "";
  const lot = raw.lot ?? raw.Lot ?? "";
  const address = raw.address ?? raw.Address ?? "";

  return {
    key: String(id),
    firstName: firstName || RECIPIENT_EMPTY_VALUE,
    lastName: lastName || RECIPIENT_EMPTY_VALUE,
    phoneNumber: phoneNumber ? formatPhone(phoneNumber) : "—",
    residentKey: residentKey || "—",
    residentContactKey: residentContactKey || "—",
    block: block || "—",
    lot: lot || "—",
    address: address || "—",
  };
}